const caDividendType = {
  FINAL: 'Final',
  INTERIM: 'Interim',
  REGULAR: 'Regular',
  SPECIAL: 'Special',
};

const caWithholdingTaxRate = {
  RATE_0: '0%',
  RATE_35: '35%',
};

const caStatus = {
  ANNOUNCEMENT_UNCONFIRMED: 'Announcement Incomplete',
  ANNOUNCEMENT_CONFIRMED: 'Announcement Completed',
  ANNOUNCEMENT_INCOMPLETE: 'Announcement Incomplete',
  ANNOUNCEMENT_COMPLETED: 'Announcement Completed',
  ANNOUNCEMENT_WITHDRAWN: 'Announcement Withdrawn',
  ELIGIBILITY_AWAITING: 'Eligibility Awaited',
  ELIGIBILITY_DECLARED: 'Eligibility Declared',
  ELIGIBILITY_DECLARATION_FAILED: 'Eligibility Declaration Failed',
  ENTITLEMENT_CREATED: 'Entitlement Created',
  ENTITLEMENT_CREATION_FAILED: 'Entitlement Creation Failed',
  RESERVATION_AWAITED: 'Reservation Awaited',
  RESERVATION_FAILED: 'Reservation Failed',
  RECONCILIATION_COMPLETED: 'Reconciliation Completed',
  PROCESSING_COMPLETE: 'Processing Completed',
};

const caProcess = {
  DISTRIBUTION: 'Distribution',
  REORGANISATION: 'Reorganisation',
};

const caLifecycle = {
  MANDATORY: 'Mandatory',
};

const caBpiStatus = {
  NO_AUTOMATED_TRANSACTION_MNGMT: 'No automated Transaction Mngmt',
};

const caOptionType = {
  CASH: 'Cash',
  SECU: 'Securities',
  LAPSE: 'Lapse',
  CASE: 'Cash & Securities',
};

const caFractionDisposition = {
  CASH_IN_LIEU: 'Cash In Lieu',
  ROUND_TO_NEAREST: 'Round To Nearest',
  ROUND_DOWN: 'Round Down',
  ROUND_UP: 'Round Up',
  ISSUE_FRACTION: 'Issue Fractions',
};

const systemSegment = {
  BUSINESS_DATE: 'Business date',
  TRADING: 'Trading',
  SETTLEMENT: 'Settlement',
  CASH_OUT_SETTLEMENT: 'CHF Detokenization',
  CASH_OUT_EUR_SETTLEMENT: 'EUR Detokenization',
  CA_EOD_PROCESSING: 'C/A EoD Processing',
};

const windowStatus = {
  PRE_OPEN: 'Pre-open',
  OPEN: 'Open',
  CLOSED: 'Closed',
};

const paymentCode = {
  C091: '091 (General - Compliance payment)',
  C092: '092 (General - Direct payment)',
  C491: '491 (Securities - Compliance payment)',
  C492: '492 (Securities - Direct payment)',
};

const returnInitiator = {
  CREDITOR_AGENT: 'Creditor Agent',
  CREDITOR: 'Creditor',
};

const originalMessageType = {
  PACS_008: 'PACS.008',
  PACS_009: 'PACS.009',
};

// TODO: add more items here when necessary
type Entities =
  | 'asset'
  | 'interestPayment'
  | 'member'
  | 'account'
  | 'whitelistedAddress'
  | 'externalEntity'
  | 'legalEntity'
  | 'currency'
  | 'centralSecuritiesDepository'
  | 'settlementInstruction'
  | 'paymentInstruction'
  | 'corporateActionEvent'
  | 'corporateActionProfile'
  | 'schedulerRuntimeSchedule'
  | 'outstandingCashBalance'
  | 'accountBalanceReport'
  | 'transactionReport'
  | 'settlementInstructionReport'
  | 'paymentInstructionReport'
  | 'memberCurrencyEligibilityConfig'
  | 'caStatusHistoryItem'
  | 'caSecuritiesMovement'
  | 'movement'
  | 'tradingParticipant'
  | 'standingSettlementInstruction'
  | 'memberSubscription'
  | 'externalAccount';

interface EntitiesOptions {
  field?: Record<string, FieldOptions>;
  dropText?: Record<string, Pick<FieldOptions, 'description'>>;
  header?: Record<string, FieldOptions>;
  generic?: Record<string, Omit<FieldOptions, 'enums'>>;
  category?: Record<string, Record<string, Omit<FieldOptions, 'enums'>> | Omit<FieldOptions, 'enums'>>;
  typeSelector?: Record<string, Omit<FieldOptions, 'enums'>>;
}

interface FieldOptions {
  label?: string;
  typeLabel?: string;
  overviewLabel?: string;
  description?: string;
  enums?: Record<string, string>;
  dropText?: string;
}

type LabelAndDescType = Record<Entities, EntitiesOptions>;

const settlementInstructionSubTypes = {
  dvp: { label: 'DvP - Delivery versus Payment', overviewLabel: 'DvP' },
  rvp: { label: 'RvP - Receive versus Payment', overviewLabel: 'RvP' },
  dfp: { label: 'DfP - Delivery free of Payment', overviewLabel: 'DfP' },
  rfp: { label: 'RfP - Receive free of Payment', overviewLabel: 'RfP' },
  pmo: { label: 'PMO - Pay Money Only', overviewLabel: 'PMO' },
  rmo: { label: 'RMO - Receive Money Only', overviewLabel: 'RMO' },
  caDfp: { label: 'C/A DfP - Delivery free of Payment', overviewLabel: 'C/A DfP' },
  caRfp: { label: 'C/A RfP - Receive free of Payment', overviewLabel: 'C/A RfP' },
  caPmo: { label: 'C/A PMO - Pay Money Only', overviewLabel: 'C/A PMO' },
  caRmo: { label: 'C/A RMO - Receive Money Only', overviewLabel: 'C/A RMO' },
  ccDeposit: { label: 'Deposit', overviewLabel: 'Deposit' },
  ccWithdrawal: { label: 'Withdrawal', overviewLabel: 'Withdrawal' },
  ccIntraWithdrawal: { label: 'Withdrawal (intra node)', overviewLabel: 'Intra-Withdrawal' },
};
const labelAndDesc: LabelAndDescType = {
  asset: {
    generic: {
      overviewTitle: {
        label: 'Asset Overview',
      },
      subType: {
        label: 'Instrument Type',
      },
      disclaimer: {
        label: 'Cryptocurrencies can only be selected by members of SDX Web3 AG',
      },
      title: {
        label: 'New Asset',
      },
    },
    header: {
      technicalIssuerAliasName: {
        label: 'Technical Issuer',
      },
      payingAgentAliasName: {
        label: 'Paying Agent',
      },
    },
    field: {
      caWithholdingRate: {
        label: 'C/A Auto-Creation Withholding Tax Rate (%)',
      },
      interestCurrencyCode: {
        label: 'Interest Currency',
      },
      denominationCurrencyCode: {
        label: 'Denomination Currency',
      },
      industrySectorDescription: {
        label: 'Industry Sector',
      },
      dti: {
        label: 'Digital Token Identifier',
      },
      jurisdictionOfIssuance: {
        label: '2-Character Country Code',
      },
      interestPayments: {
        label: 'Interest Payments Details',
        typeLabel: 'Interest Payments Details',
      },
      detailTypeSelector: {
        enums: {
          DEPOSITARY_RECEIPT: 'Depositary Receipt (DR)',
        },
      },
      dayCountMethod: {
        enums: {
          A000: 'A000 - No accrued interest',
          A001: 'A001 - 30/360 American Basic Rule',
          A004: 'A004 - Actual/360',
          A005: 'A005 - Actual/365',
          A006: 'A006 - Actual/Actual',
          A009: 'A009 - Actual/365L',
          A010: 'A010 - Actual/Actual',
          A011: 'A011 - 30/360 basic rule',
          A013: 'A013 - Eurobond basis model 3',
        },
      },
      interestType: {
        enums: {
          FIXED: 'Fixed',
          VARIABLE: 'Variable',
          FLOATING: 'Floating',
        },
      },
      variableInterestType: {
        enums: {
          RISK_FREE: 'Risk-free',
        },
      },
      interestRateSource: {
        enums: {
          SARON: 'Saron',
          EURIBOR: 'Euribor',
        },
      },
      businessDayConvention: {
        description: 'If no value is captured, system will default the value "Unadjusted"',
        enums: {
          ADJUSTED: 'Adjusted',
          UNADJUSTED: 'Unadjusted',
        },
      },
      paymentDateAdjustmentConvention: {
        description: 'If no value is captured, system will default the value as "Following"',
      },
    },
    dropText: {
      paymentDateAdjustmentConvention: {
        description:
          'Attribute defines if interest period is to be adjusted, including accrued interest until payment date, or if only the payment date is to be adjusted',
      },
      shortDescription: {
        description: "Max. 35 characters, a-z A-Z 0-9 / - ? : ( ) . , ' + ",
      },
    },
  },
  interestPayment: {
    field: {
      paymentDate: {
        label: 'Coupon Date',
      },
    },
  },
  member: {
    generic: {
      overviewTitle: {
        label: 'Member Overview',
      },
      title: {
        label: 'New Member',
      },
    },
    field: {
      sdxMemberId: {
        label: 'SDX Member ID',
      },
      qiStatus: {
        enums: {
          UNDOCUMENTED: 'Undocumented',
          WITHHOLDING_QI: 'Withholding QI',
          NON_WITHHOLDING_QI: 'Non-Withholding QI',
          NON_QI: 'Non QI',
        },
      },
    },
    dropText: {
      name: {
        description: 'max. 50 characters',
      },
      aliasName: {
        description: 'max. 11 characters',
      },
    },
  },
  account: {
    generic: {
      overviewTitle: {
        label: 'Account Overview',
      },
      title: {
        label: 'New Account',
      },
    },
    field: {
      processingUsages: {
        enums: {
          CA_PROCESSING: 'CA default',
          INCOMING_CASH_CREDIT: 'Incoming cash default',
          ATOMIC_OWN_ACCOUNT_TRADES: 'SDX proprietary trades default',
          ATOMIC_CLIENT_TRADES: 'SDX clients trades default',
          INCOMING_ASSETS_DEFAULT: 'Incoming assets default',
          FRACTIONALISATION_NOSTRO: 'Fractionalisation Nostro',
        },
      },
      key: {
        enums: {
          CA_PROCESSING: 'CA default',
          INCOMING_CASH_CREDIT: 'Incoming cash default',
          ATOMIC_OWN_ACCOUNT_TRADES: 'SDX proprietary trades default',
          ATOMIC_CLIENT_TRADES: 'SDX clients trades default',
          INCOMING_ASSETS_DEFAULT: 'Incoming assets default',
          FRACTIONALISATION_NOSTRO: 'Fractionalisation Nostro',
        },
      },
      accountType: {
        enums: {
          PROPRIETARY: 'Proprietary',
          CLIENT_OMNIBUS: 'Client omnibus',
          CLIENT_SEGREGATED: 'Client segregated',
          TRANSIT: 'Transit',
        },
      },
      memberId: {
        label: 'Account Owner',
      },
      alternateId: {
        label: 'Account Label',
        description: 'Do not enter any client identifying data (CID)',
      },
    },
    dropText: {
      account: {
        description: 'Account ID should be a 6-digit number not starting from 0',
      },
      iban: {
        description: 'IBAN must be in the following format: ^([A-Z]{2})([0-9]{2})([a-zA-Z0-9]{1,30})$',
      },
      openingDate: {
        description: 'The opening date should be later or equal to the current business date',
      },
      closingDate: {
        description: 'The closing date must be later than both the opening date and the current date',
      },
      alternateId: {
        description: 'Maximum length of field is 140 characters',
      },
      usWithholdingTaxRate: {
        description: 'If US WHT Rate is empty  or is not approved by SDX OPS, maximum US WHT rate will be applied',
      },
    },
  },
  whitelistedAddress: {
    generic: {
      overviewTitle: {
        label: 'Whitelisted Address Overview',
      },
      overviewCreate: {
        label: 'Create Address',
      },
    },
    field: {
      typeSelector: {
        label: 'Processing Usage',
      },
      status: {
        enums: {
          REQUESTED: 'Requested',
          PENDING_COMPLIANCE_CHECK: 'Pending Compliance Check',
          ACTIVE: 'Active',
          SUSPENDED: 'Suspended',
        },
      },
    },
  },
  externalEntity: {
    generic: {
      overviewTitle: {
        label: 'External Entity Overview',
      },
      overviewCreate: {
        label: 'Create External Entity',
      },
    },
    field: {
      typeSelector: {
        label: 'Entity Type',
      },
      status: {
        enums: {
          REQUESTED: 'Requested',
          ACTIVE: 'Active',
          SUSPENDED: 'Suspended',
        },
      },
    },
  },
  legalEntity: {
    generic: {
      overviewTitle: {
        label: 'Legal Entity Overview',
      },
      overviewCreate: {
        label: 'Create Legal Entity',
      },
      title: {
        label: 'New Legal Entity',
      },
    },
    field: {
      countryOfIncorporation: {
        label: 'Tax Domicile',
      },
      incorporationCountry: {
        label: 'Country of Incorporation',
      },
    },
    dropText: {
      name: {
        description: 'max. 100 characters',
      },
    },
  },
  currency: {
    generic: {
      overviewTitle: {
        label: 'Currency Overview',
      },
      title: {
        label: 'New Currency',
      },
    },
    dropText: {
      name: {
        description: 'max. 50 characters',
      },
    },
  },
  centralSecuritiesDepository: {
    generic: {
      overviewTitle: {
        label: 'Depositories Overview',
      },
      overviewCreate: {
        label: 'Create Depository',
      },
      title: {
        label: 'New Depository',
      },
    },
  },
  settlementInstruction: {
    generic: {
      title: {
        label: 'New Settlement Instruction',
      },
      subType: {
        label: 'Instruction Type',
      },
      subTypeGroup: {
        label: 'Transaction category',
      },
    },
    header: {
      instructingPartyAliasName: {
        label: 'Instr. Party',
      },
      accountOwnerTransactionId: {
        label: 'Transaction ID',
      },
    },
    dropText: {
      counterParty: {
        description: 'Please select a counterparty member available in the system',
      },
      accountOwnerTransactionId: {
        description: "Must be unique per member, max. 16 characters, a-z A-Z 0-9 / - ? : ( ) . , ' +",
      },
      intendedSettlementDate: {
        description: 'The settlement date must be equal to or greater than the issuance date',
      },
      asset: {
        description: 'The asset must be active',
      },
      safekeepingAccount: {
        description: 'The safekeeping account must be active',
      },
      settlementAmountCurrency: {
        description: 'Must be listed in the list of available currency',
      },
      tradeDate: {
        description: 'The trade date must be equal or less than the current business day',
      },
      settlementAmount: {
        description: 'Settlement amount cannot be 0',
      },
      settlementQuantity: {
        description: 'Settlement quantity cannot be 0',
      },
      corporateActionEventIdentification: {
        description: "Max. 16 characters, a-z A-Z 0-9 / - ? : ( ) . , ' +",
      },
    },
    field: {
      priceType: {
        enums: {
          PER_UNIT: 'PER UNIT',
        },
      },
      safekeepingAccount: {
        label: 'Safekeeping Account',
      },
      asset: {
        label: 'Asset',
      },
      intendedSettlementDate: {
        label: 'Intended Settlement Date',
      },
      settlementAmountCurrency: {
        label: 'Settlement Currency',
      },
      dealPriceValueAmount: {
        label: 'Trade price',
      },
      dealPriceValueRate: {
        label: 'Trade rate',
      },
      settlingCapacityCode: {
        label: 'Settling Capacity',
        enums: {
          CUST: 'Settling Custodian (CUST)',
          SPRI: 'Settling Principal (SPRI)',
          SAGE: 'Settling Agent (SAGE)',
          RISP: 'Riskless Principal (RISP)',
        },
      },
      tradeDate: {
        label: 'Trade Date',
      },
      counterParty: {
        label: 'Counterparty',
      },
      accountOwnerTransactionId: {
        label: 'Transaction ID',
      },
      corporateActionEvent: {
        label: 'C/A Event',
      },
      corporateActionEventIdentification: {
        label: 'C/A Reference',
      },
      csdHold: {
        label: 'CSD Hold',
      },
      linkagesProcessingPositionCode: {
        label: 'Linkage Indicator',
      },
      linkedInstructingPartyTransactionId: {
        label: 'Linked Instruction',
      },
      reportingCode: {
        enums: {
          DELAY0: 'Publish without delay',
          DELAY1: 'Publish with delay',
        },
      },
      deliveringBlockchain: {
        label: 'Source Blockchain',
      },
      deliveringAddress: {
        label: 'Source Blockchain Address',
      },
      receivingAddress: {
        label: 'Target Blockchain Address',
      },
      receivingBlockchain: {
        label: 'Target Blockchain',
      },
      priority: {
        enums: {
          HIGH_FEES_GROSS: 'High Fees Gross',
          HIGH_FEES_NET: 'High Fees Net',
          MEDIUM_FEES_GROSS: 'Medium Fees Gross',
          MEDIUM_FEES_NET: 'Medium Fees Net',
        },
      },
      processingStatusReasonCode: {
        enums: {
          CC_INITIAL_COMPLIANCE_CHECK: 'Initial Compliance Check',
          CC_EXTERNAL_PROCESSING: 'External Processing',
          CC_FINAL_COMPLIANCE_CHECK: 'Final Compliance Check',
          CC_EXTERNALLY_ACCEPTED: 'Externally Accepted',
          CC_EXTERNALLY_REJECTED: 'Externally Rejected',
          CC_PENDING_RESERVATION: 'Pending Reservation',
          CC_RESERVED: 'Reserved',
          CC_PENDING_SETTLEMENT: 'Pending Settlement',
          CROSS_CSD_EXTERNAL_PROCESSING: 'EXTERNAL PROCESSING',
          CROSS_CSD_EXTERNALLY_ACCEPTED: 'EXTERNALLY ACCEPTED',
          CROSS_CSD_EXTERNALLY_REJECTED: 'EXTERNALLY REJECTED',
          CROSS_CSD_EXTERNALLY_SETTLED: 'EXTERNALLY SETTLED',
          CROSS_CSD_EXTERNALLY_CANCELLED: 'EXTERNALLY CANCELLED',
          CROSS_CSD_PENDING_RESERVATION: 'PENDING RESERVATION',
          CROSS_CSD_RESERVED: 'RESERVED',
          CROSS_CSD_EXTERNALLY_MATCHED: 'EXTERNALLY MATCHED',
          CROSS_CSD_EXTERNALLY_UNMATCHED: 'EXTERNALLY UNMATCHED',
        },
      },
    },
    typeSelector: {
      ...settlementInstructionSubTypes,
      at: { label: 'AT - Account Transfer', overviewLabel: 'AT' },
      issuance: { label: 'Issuance' },
      deissuance: { label: 'Deissuance' },
    },
  },
  memberSubscription: {
    category: {
      isoMessageCustomizationService: {
        description: 'Controls if the ISO messages are sent (true) or not (false)',
      },
      transferRestrictions: {
        description:
          'By selecting the checkbox below, we hereby confirm that we understand and agree that SDX shall have no obligation to verify whether any member of SDX complies with the defined restrictions. Furthermore, we acknowledge and accept that SDX shall bear no liability whatsoever in connection with any non-compliance by members with such restrictions',
      },
    },
  },
  paymentInstruction: {
    generic: {
      title: {
        label: 'New Payment Instruction',
      },
    },
    dropText: {
      paymentAmount: {
        description: 'Payment amount should be greater than zero',
      },
      transactionId: {
        description: "Must be unique per member, max. 16 characters, a-z A-Z 0-9 / - ? : ( ) . , ' + ",
      },
      endToEndId: {
        description: "Max. 35 characters, a-z A-Z 0-9 / - ? : ( ) . , ' + ",
      },
      instructionId: {
        description: "Max. 35 characters, a-z A-Z 0-9 / - ? : ( ) . , ' + ",
      },
    },
    category: {
      compensationDetokenization: {
        creditor: {
          description: 'Mandatory Block. Either [Creditor BIC] OR [Creditor ID AND Creditor Sysid Code]',
        },
      },
      detokenizationReturn: {
        externalInstructingAgent: {
          description: 'Either [Instructing Agent BIC] OR [Instructing Agent ID AND Instructing Agent Sysid Code]',
        },
        creditor: {
          description:
            'Either [Creditor BIC] OR [Creditor ID AND Creditor Sysid Code] OR [Creditor Name AND Creditor Postal Address]. ' +
            'Name and Address can optionally be used with the first two options',
        },
        creditorAgent: {
          description: 'Either [Creditor Agent BIC] OR [Creditor Agent ID AND Creditor Agent Sysid Code]',
        },
        debtorAgent: {
          description: 'Either [Debtor Agent BIC] OR [Debtor Agent ID AND Debtor Agent Sysid Code]',
        },
        debtor: {
          description:
            'Either [Debtor BIC] OR [Debtor ID AND Debtor Sysid Code] OR [Debtor Name AND Debtor Postal Address]. ' +
            'Name and Address can optionally be used with the first two options',
        },
      },
      detokenization: {
        creditor: {
          description:
            'Mandatory Block. Either [Creditor BIC] OR [Creditor ID AND Creditor Sysid Code] OR [Creditor Name AND Creditor Postal Address]. ' +
            'Name and Address can optionally be used with the first two options',
        },
        creditorAgent: {
          description: 'Optional Block. Either [Creditor Agent BIC] OR [Creditor Agent ID AND Creditor Agent Sysid Code]',
        },
        debtorAgent: {
          description: 'Optional Block. Either [Debtor Agent BIC] OR [Debtor Agent ID AND Debtor Agent Sysid Code]',
        },
        debtor: {
          description:
            'Optional Block. Either [Debtor BIC] OR [Debtor ID AND Debtor Sysid Code] OR [Debtor Name AND Debtor Postal Address]. Name and Address can optionally be used with the first two options',
        },
      },
      debtor: {
        description: 'Optional Block. Either [Debtor BIC] OR [Debtor ID AND Debtor Sysid Code]',
      },
      creditorAccount: {
        description: 'Optional Block. Either [Creditor IBAN] OR [Creditor Account ID]',
      },
      debtorAccount: {
        description: 'Optional Block. Either [Debtor IBAN] OR [Debtor Account ID]',
      },
      debtorAgent: {
        description: 'Optional Block. Either [Debtor Agent BIC] OR [Debtor Agent ID AND Debtor Agent Sysid Code]',
      },
      debtorAgentAccount: {
        description: 'Optional Block. Either [Debtor Agent IBAN] OR [Debtor Agent Account ID]',
      },
      creditorAgent: {
        description: 'Optional Block. Either [Creditor Agent BIC] OR [Creditor Agent ID AND Creditor Agent Sysid Code]',
      },
      creditorAgentAccount: {
        description: 'Optional Block. Either [Creditor Agent IBAN] OR [Creditor Agent Account ID]',
      },
      creditor: {
        description:
          'Mandatory Block. Either [Creditor BIC] OR [Creditor ID AND Creditor Sysid Code] OR [Creditor ' +
          'Name AND Creditor Postal Address]. Name and Address can optionally be used with the first two options',
      },
    },
    header: {
      typeSelector: {
        label: 'Payment Info',
      },
      transactionId: {
        label: 'Transaction ID',
      },
      paymentAmount: {
        label: 'Payment Amount',
      },
      requestedSettlementDate: {
        label: 'Intended Settlement Date',
      },
      instructingAgentAliasName: {
        label: 'Payer',
      },
      instructedAgentAliasName: {
        label: 'Payee',
      },
      instructionStatus: {
        label: 'Status',
      },
      updatedAt: {
        label: 'Last Update',
      },
      creationDate: {
        label: 'Business Date',
      },
    },
    field: {
      requestedSettlementDate: {
        label: 'Intended Settlement Date',
      },
      instructingAgent: {
        label: 'Payer',
        description: 'Instructing Agent',
      },
      instructedAgent: {
        label: 'Payee',
        description: 'Instructed Agent',
      },
      endToEndId: {
        label: 'End To End ID',
        description: 'Debtor Reference',
      },
      instructionId: {
        label: 'Instruction ID',
        description: 'Creditor Reference',
      },
      paymentCode: {
        enums: paymentCode,
      },
      creationDate: {
        label: 'Business Date',
      },
      returnInitiator: {
        enums: returnInitiator,
      },
      originalMessageType: {
        enums: originalMessageType,
      },
      debtorName: {
        description: 'Do not enter any client identifying data (CID)',
      },
      creditorName: {
        description: 'Do not enter any client identifying data (CID)',
      },
    },
  },
  corporateActionEvent: {
    generic: {
      title: {
        label: 'New Corporate Action',
      },
      subType: {
        label: 'C/A Type',
      },
    },
    category: {
      generalInformation: {
        label: 'General Information',
      },
      cADetails: {
        label: 'C/A Details',
      },
      optionsDetails: {
        label: 'Options Details',
      },
    },
    header: {
      assetIsin: {
        label: 'ISIN',
      },
      assetShortDescription: {
        label: 'Short Description',
      },
      payingAgentAliasName: {
        label: 'Paying Agent',
      },
      issuerAgentAliasName: {
        label: '(Technical) Issuer Agent',
      },
    },
    field: {
      typeSelector: {
        label: 'C/A Type',
      },
      sdxCaReference: {
        label: 'C/A Reference',
      },
      eventProcessingType: {
        label: 'C/A Process',
        enums: caProcess,
      },
      mandatoryVoluntaryEventType: {
        label: 'C/A Lifecycle',
        enums: caLifecycle,
      },
      eventConfirmationStatus: {
        label: 'C/A Confirmed',
      },
      eventCompletenessStatus: {
        label: 'C/A Completed',
      },
      asset: {
        label: 'Underlying Asset',
      },
      eventStatus: {
        label: 'C/A Status',
        enums: caStatus,
      },
      eventStatusHistory: {
        label: 'C/A Status History',
      },
      additionalBusinessProcessingIndicator: {
        label: 'Additional Business Process Indicator',
        enums: caBpiStatus,
      },
      payingAgent: {
        label: 'Paying Agent',
      },
      issuerAgent: {
        label: '(Technical) Issuer Agent',
      },
      dividendType: {
        label: 'Dividend Type',
        enums: caDividendType,
      },
      announcementDate: {
        label: 'Announcement Date',
      },
      meetingDate: {
        label: 'Meeting Date',
      },
      paymentDate: {
        label: 'Payment Date',
      },
      exDividendDate: {
        label: 'Ex Dividend Date',
        description: 'Default Value = Record Date -1 SDX business day.',
      },
      recordDate: {
        label: 'Record Date',
        description: 'Default Value = Payment Date -1 SDX business day.',
      },
      lastTradingDate: {
        label: 'Last Trading Date',
        description: 'Default Value = Record Date -2 SDX business days.',
      },
      couponNumber: {
        label: 'Coupon Number',
      },
      nextCouponDate: {
        label: 'Next Coupon Date',
      },
      interestPeriodStartDate: {
        label: 'Interest Period Start Date',
      },
      interestPeriodEndDate: {
        label: 'Interest Period End Date',
      },
      dayCountBasis: {
        label: 'Day Count Basis',
        enums: {
          IC_30_365: 'IC30365',
          IC_30_360_ISDA_OR_30_360_AMERICAN_BASIC_RULE: 'IC30360ISDAor30360AmericanBasicRule',
          IC_30_ACTUAL: 'IC30Actual',
          ACTUAL_360: 'Actual360',
          ACTUAL_365_FIXED: 'Actual365Fixed',
          ACTUAL_ACTUAL_ICMA: 'ActualActualICMA',
          IC_30_E_360_OR_EURO_BOND_BASIS_MODEL_1: 'IC30E360orEuroBondBasismodel1',
          ACTUAL_ACTUAL_ISDA: 'ActualActualISDA',
          ACTUAL_365L_OR_ACTU_ACTU_BASIS_RULE: 'Actual365LorActuActuBasisRule',
          ACTUAL_ACTUAL_AFB: 'ActualActualAFB',
          IC_30_360_ICMA_OR_30_360_BASIC_RULE: 'IC30360ICMAor30360basicrule',
          IC_30_E2_360_OR_EURO_BOND_BASIS_MODEL_2: 'IC30E2360orEurobondbasismodel2',
          IC_30_E3_360_OR_EURO_BOND_BASIS_MODEL_3: 'IC30E3360orEurobondbasismodel3',
          ACTUAL_365_NL: 'Actual365NL',
        },
      },
      interestAccruedDays: {
        label: 'Interest accrued Days',
      },
      optionNumber: {
        label: 'Option Number',
      },
      optionType: {
        label: 'Option Type',
        enums: caOptionType,
      },
      defaultProcessingIndicator: {
        label: 'Default Processing Indicator',
      },
      optionCurrency: {
        label: 'Option Currency',
      },
      creditDebitIndicator: {
        label: 'Credit/Debit Indicator',
      },
      underlyingAsset: {
        label: 'Underlying Asset',
      },
      grossRateCurrency: {
        label: 'Gross Rate (Currency)',
      },
      grossRateAmount: {
        label: 'Gross Rate (Amount)',
      },
      grossRatePct: {
        label: 'Gross Rate (%)',
      },
      redemptionPricePct: {
        label: 'Redemption Price (%)',
      },
      partialRedemptionRate: {
        label: 'Partial Redemption Rate (%)',
      },
      withholdingTaxRate: {
        label: 'Withholding Tax Rate',
        enums: caWithholdingTaxRate,
      },
      netAmount: {
        label: 'Net (Amount)',
      },
      netPercentage: {
        label: 'Net Rate (%)',
      },
      securitiesMovements: {
        label: 'Securities Movements',
        typeLabel: 'Securities Movements',
      },
    },
    dropText: {
      newNominalValue: {
        description: 'Value is populated to asset, after C/A completion.',
      },
    },
  },
  caStatusHistoryItem: {
    field: {
      status: {
        enums: caStatus,
      },
    },
  },
  caSecuritiesMovement: {
    field: {
      fractionDisposition: {
        label: 'Disposition of Fractions',
        enums: caFractionDisposition,
      },
    },
  },
  schedulerRuntimeSchedule: {
    field: {
      segment: {
        enums: systemSegment,
      },
      status: {
        enums: windowStatus,
      },
    },
  },
  outstandingCashBalance: {
    header: {
      currencyTechnicalIssuerAliasName: {
        label: 'Technical Issuer',
      },
      currencyCode: {
        label: 'Currency Code',
      },
      currencyName: {
        label: 'Currency Name',
      },
      totalIssuedAmount: {
        label: 'Balance',
      },
    },
  },
  accountBalanceReport: {
    field: {
      total: {
        label: 'Total',
      },
      currencyCode: {
        label: 'Currency Code',
      },
      currencyName: {
        label: 'Currency Name',
      },
      memberId: {
        label: 'Member ID',
      },
      memberAlias: {
        label: 'Member Alias',
      },
    },
  },
  transactionReport: {
    field: {
      amount: {
        label: 'Amount',
      },
      currencyCode: {
        label: 'Currency Code',
      },
      currencyName: {
        label: 'Currency Name',
      },
      memberId: {
        label: 'Member ID',
      },
      memberAlias: {
        label: 'Member Alias',
      },
      debitCredit: {
        label: 'Debit/Credit',
      },
      dateTime: {
        label: 'DateTime',
      },
    },
  },
  memberCurrencyEligibilityConfig: {
    field: {
      member: {
        label: 'Member',
      },
      Currency: {
        label: 'Currency',
      },
    },
  },
  settlementInstructionReport: {
    field: {
      typeSelector: {
        enums: {
          DVP: 'DvP',
          DFP: 'DfP',
          RVP: 'RvP',
          RFP: 'RfP',
          ISSUANCE: 'Issuance',
          DEISSUANCE: 'Deissuance',
          CROSS_CSD_RFP: 'Cross CSD - Receive free of payment',
          CROSS_CSD_DFP: 'Cross CSD - Delivery free of payment',
          CA_PMO: 'C/A PMO',
          CA_RFP: 'C/A RfP',
          CA_RMO: 'C/A RMO',
          CA_DFP: 'C/A DfP',
          CA_DVP: 'C/A DvP',
          CA_RVP: 'C/A RvP',
          CC_WITHDRAWAL: 'Withdrawal',
          ASSET_SUB_BALANCE_TRANSFER: 'Asset Sub-balance Transfer',
          CC_INTRA_WITHDRAWAL: 'Intra-Withdrawal',
          ON_EXCHANGE_DVP: 'On-Exchange DvP',
          ON_EXCHANGE_RVP: 'On-Exchange RvP',
          CC_DEPOSIT: 'Deposit',
        },
      },
    },
  },
  paymentInstructionReport: {
    field: {
      typeSelector: {
        enums: {
          TOKENIZATION: 'Tokenization',
          TOKENIZATION_CUSTOMER: 'Tokenization customer',
          DETOKENIZATION: 'Detokenization',
          INTER_NODE_TRANSFER: 'Inter-node transfer',
          INTRA_NODE_TRANSFER: 'Intra-node transfer',
          MANUAL_TOKENIZATION: 'Manual tokenization',
          MANUAL_DETOKENIZATION: 'Manual detokenization',
          COMPENSATION_DETOKENIZATION: 'Compensation detokenization',
          DETOKENIZATION_RETURN: 'Tokenization return',
          SUB_BALANCE_TRANSFER: 'Sub-balance transfer',
        },
      },
    },
  },
  movement: {
    field: {
      instructionTransactionId: {
        label: 'Transaction ID',
      },
    },
  },
  tradingParticipant: {
    generic: {
      overviewTitle: {
        label: 'Trading Participant Overview',
      },
      title: {
        label: 'New Trading Participant',
      },
    },
    field: {
      tradingParticipantId: {
        label: 'ID',
      },
    },
    dropText: {
      tradingParticipantId: {
        description: 'Please enter same TP ID as used in TradRef',
      },
      name: {
        description: 'Please use the following pattern [0-9a-zA-Z !"#$%&\'()*-./:;<=>?[]_{}^] for a maximum of 60 characters',
      },
    },
  },
  standingSettlementInstruction: {
    generic: {
      overviewTitle: {
        label: 'Standing Settlement Instruction',
      },
      title: {
        label: 'New SSI',
      },
    },
    field: {
      propertySafeAccount: {
        label: 'Safekeeping Account',
      },
      propertyCashAccount: {
        label: 'Cash Account',
      },
      clientsSafeAccount: {
        label: 'Safekeeping Account',
      },
      clientsCashAccount: {
        label: 'Cash Account',
      },
    },
    dropText: {
      name: {
        description: 'At least one and not more than 35 characters allowed, not starting or ending with whitespace',
      },
    },
  },
  externalAccount: {
    category: {
      externalPartyDetails: {
        description:
          'Mandatory Block. Either [External Party Identifier BIC] OR [External Party Identifier ID AND External Party Identifier Sysid Code]',
      },
    },
    field: {
      externalAccountType: {
        enums: {
          CASH: 'Cash',
        },
      },
      externalPlatform: {
        enums: {
          SIC: 'SIC',
        },
      },
      externalAccountProcessingUsages: {
        enums: {
          EOD_AUTO_DETOKENIZATION: 'EOD Auto-Detokenization',
        },
      },
    },
    dropText: {
      externalAccountIdentifier: {
        description: 'Must be valid IBAN format',
      },
    },
  },
  corporateActionProfile: {
    generic: {
      title: {
        label: 'New C/A profile',
      },
    },
    field: {
      payingAgentCashAccount: {
        label: 'Cash Account',
      },
      payingAgentSecuritiesAccount: {
        label: 'Securities Account',
      },
      holderCashAccount: {
        label: 'Cash Account',
      },
      holderSecuritiesAccount: {
        label: 'Securities Account',
      },
    },
  },
};

export default labelAndDesc;
